module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    ref: "ordercontainer",
    staticClass: "order-container common-container"
  }, [_c('section', {
    staticClass: "data-oper"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8,
      "align": "left"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editData
    }
  }, [_vm._v("添加")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editCol
    }
  }, [_vm._v("设置显示列")]), _vm._v(" "), _c('el-button', {
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "left"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按培训公司搜索"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.aagencyid),
      callback: function($$v) {
        _vm.aagencyid = $$v
      },
      expression: "aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "日期起",
      "picker-options": _vm.startPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.voucherTimeChange('start')
      }
    },
    model: {
      value: (_vm.voucherStartime),
      callback: function($$v) {
        _vm.voucherStartime = $$v
      },
      expression: "voucherStartime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "center"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "clearable": "",
      "placeholder": "日期止",
      "picker-options": _vm.endPickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.voucherTimeChange('end')
      }
    },
    model: {
      value: (_vm.voucherEndtime),
      callback: function($$v) {
        _vm.voucherEndtime = $$v
      },
      expression: "voucherEndtime"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3,
      "align": "center"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "按消费筛选"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.used),
      callback: function($$v) {
        _vm.used = $$v
      },
      expression: "used"
    }
  }, _vm._l((_vm.usedOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2,
      "align": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索字段"
    },
    on: {
      "change": _vm.searchColumn
    },
    model: {
      value: (_vm.fuzzyField),
      callback: function($$v) {
        _vm.fuzzyField = $$v
      },
      expression: "fuzzyField"
    }
  }, _vm._l((_vm.fuzzyFieldOptions), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.value,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4,
      "align": "ceter"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "搜索内容"
    },
    on: {
      "change": _vm.searchList
    },
    model: {
      value: (_vm.vague),
      callback: function($$v) {
        _vm.vague = $$v
      },
      expression: "vague"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "data-content",
    attrs: {
      "data": _vm.datas,
      "stripe": true,
      "height": _vm.containerHeight - 85,
      "highlight-current-row": "",
      "id": "out-table",
      "border": "",
      "row-key": "id"
    }
  }, [_c('af-table-column', {
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.pageNum - 1) * _vm.pageSize + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.colUnShowKeys.indexOf('id') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "id",
      "label": "返单券ID",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('amount') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "amount",
      "label": "返单券金额",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('gmtCreate') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "gmtCreate1",
      "label": " 赠送日期",
      "formatter": _vm.formatGmtCreate,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('gmtCreatetime') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "gmtCreate2",
      "label": " 赠送时间",
      "formatter": _vm.formatGmtCreatetime,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercareter') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercareter",
      "label": "客户编码",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('ordercaretername') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "ordercaretername",
      "label": "客户姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('aagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "aagencyname",
      "label": "培训公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('pagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "pagencyname",
      "label": "销售公司",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('cagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "cagencyname",
      "label": "代理1",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('tagencyname') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "tagencyname",
      "label": "代理2",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consignee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consignee",
      "label": "收货人姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('consigneePhone') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "consigneePhone",
      "label": "收货人电话",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('province') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "province",
      "label": "省",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('city') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "city",
      "label": "市",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('district') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "district",
      "label": "县（区）",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('address') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "address",
      "label": "收货人地址",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('franchisee') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "franchisee",
      "label": "加盟商姓名",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('used') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "used",
      "label": "是否已消费",
      "formatter": _vm.formatUsed,
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('usedOrderCode') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "usedOrderCode",
      "label": "消费订单号",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.colUnShowKeys.indexOf('remark') === -1) ? _c('af-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "left"
    }
  }) : _vm._e(), _vm._v(" "), _c('af-table-column', {
    key: Math.random(),
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "130",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.used === 0) ? _c('span', [_c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v("|\n\t\t\t\t\t\t"), _c('label', {
          staticClass: "hzpedit",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.delData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('pagination', {
    attrs: {
      "pageSize": _vm.pageSize,
      "pageNum": _vm.pageNum,
      "totalNum": _vm.totalNum
    },
    on: {
      "handlePageSizeChange": _vm.handlePageSizeChange,
      "handlePageCurrentChange": _vm.handlePageCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": "设置显示列",
      "visible": _vm.colDialogVisible,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.colDialogVisible = $event
      },
      "close": _vm.closeColSet
    }
  }, [_c('el-transfer', {
    staticStyle: {
      "width": "500px",
      "margin": "15px auto"
    },
    attrs: {
      "data": _vm.colDatas,
      "titles": ['显示列', '不显示列']
    },
    model: {
      value: (_vm.colUnShowKeys),
      callback: function($$v) {
        _vm.colUnShowKeys = $$v
      },
      expression: "colUnShowKeys"
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog-container",
    attrs: {
      "title": _vm.dialogTitle + '数据',
      "visible": _vm.editDialogVisible,
      "width": "800px"
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialogVisible = $event
      },
      "opened": _vm.openDialog
    }
  }, [_c('el-form', {
    ref: "formData",
    staticClass: "form-data",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules,
      "label-width": "100px",
      "size": "mini"
    }
  }, [_c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返单券ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.formData.id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "id", $$v)
      },
      expression: "formData.id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单编号",
      "prop": "orderCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.formData.orderCode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "orderCode", $$v)
      },
      expression: "formData.orderCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('label', {
    staticClass: "hzpedit",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchData.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人姓名",
      "prop": "ordercaretername"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    model: {
      value: (_vm.formData.ordercaretername),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercaretername", $$v)
      },
      expression: "formData.ordercaretername"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单人编号",
      "prop": "ordercareter"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.unEditEnable
    },
    model: {
      value: (_vm.formData.ordercareter),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ordercareter", $$v)
      },
      expression: "formData.ordercareter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "培训公司",
      "prop": "aagencyid"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "97%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.searchAgencyname($event)
      }
    },
    model: {
      value: (_vm.formData.aagencyid),
      callback: function($$v) {
        _vm.$set(_vm.formData, "aagencyid", $$v)
      },
      expression: "formData.aagencyid"
    }
  }, _vm._l((_vm.agencyDatas), function(item) {
    return _c('el-option', {
      key: item.aagencyid,
      attrs: {
        "label": item.aagencyname,
        "value": item.aagencyid
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售公司",
      "prop": "pagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.pagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pagencyname", $$v)
      },
      expression: "formData.pagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理1",
      "prop": "cagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.cagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cagencyname", $$v)
      },
      expression: "formData.cagencyname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理2",
      "prop": "tagencyname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.tagencyname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "tagencyname", $$v)
      },
      expression: "formData.tagencyname"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人姓名",
      "prop": "consignee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consignee", $$v)
      },
      expression: "formData.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返单券金额",
      "prop": "amount",
      "id": "focus-ele"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", $$v)
      },
      expression: "formData.amount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "加盟商姓名",
      "prop": "franchisee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.franchisee),
      callback: function($$v) {
        _vm.$set(_vm.formData, "franchisee", $$v)
      },
      expression: "formData.franchisee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人电话",
      "prop": "consigneePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.consigneePhone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "consigneePhone", $$v)
      },
      expression: "formData.consigneePhone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "省市县(区)",
      "prop": "province"
    }
  }, [_c('region-picker', {
    attrs: {
      "placeholder": {
        province: '选择省份',
        city: '选择市',
        district: '选择县（区）'
      },
      "province": _vm.formData.region.province,
      "city": _vm.formData.region.city,
      "district": _vm.formData.region.district
    },
    on: {
      "onchange": _vm.regionChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "order-edit-row"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备    注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.formData.remark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remark", $$v)
      },
      expression: "formData.remark"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "hzpbtn-close",
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "hzpbtn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保 存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d323ebfc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/voucherManagement/Voucher.vue
// module id = 718
// module chunks = 1